var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"main-layout w-full flex",class:_vm.layoutClass},[_c('MainMenu'),_c('div',{staticClass:"main-layout-content h-full w-full flex flex-col",class:_vm.contentClass},[_c('MainHeader'),_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }